import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_FI.json';
import exercises from './PILATES_EXERCISES_FI.json';
import recipes from './PILATES_RECIPES_FI.json';

export const PILATES_DATA_FI: ServiceData = {
  articles,
  exercises,
  recipes,
};
